/** 轻量探测 RPC 往返延迟（eth_blockNumber），用于设置页网络排查 */
export async function probeRpcLatency(rpcUrl, { timeoutMs = 8000 } = {}) {
  const url = String(rpcUrl || '').trim()
  if (!url) return null
  const start = performance.now()
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ jsonrpc: '2.0', method: 'eth_blockNumber', params: [], id: 1 }),
      signal: controller.signal,
    })
    clearTimeout(timer)
    if (!res.ok) return null
    const json = await res.json()
    if (json?.error) return null
    return Math.round(performance.now() - start)
  } catch {
    clearTimeout(timer)
    return null
  }
}
